module.exports = __webpack_public_path__ + "img/daishou.5b6b56a2.png";